export const resource = {
  colors: {
    borderOutlineColor: "#CCCCCC",
    activeColor: "#004D99",
    defaultColor: "#565656",
  },
};

export const sidebarOptions = [
  {
    name: "bio",
    label: "Profile",
    style: { color: resource.colors.activeColor, fontSize: 15 },
    isActive: true,
  },
  {
    name: "project",
    label: "Projects",
    style: { color: resource.colors.defaultColor, fontSize: 15 },
    isActive: false,
  },
  {
    name: "connect",
    label: "Connect",
    style: { color: resource.colors.defaultColor, fontSize: 15 },
    isActive: false,
  },
];

export const mainContents = [
  {
    name: "bio",
    label: "Biography",
    content: "",
    isActive: true,
    isVisible: true,
  },
  {
    name: "project",
    label: "Projects",
    content: "",
    isActive: false,
    isVisible: true,
  },
  {
    name: "connect",
    label: "Connect",
    content: "",
    isActive: true,
    isVisible: true,
  },
];
